import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[fiCustomEmail]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CustomEmailDirective, multi: true }],
    standalone: false,
})
export class CustomEmailDirective implements Validator {
    constructor() {}

    emailRegExp: RegExp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    validate(control: AbstractControl): ValidationErrors {
        let error: boolean = false;
        const result: ValidationErrors = {};

        if (!control.value || !this.emailRegExp.test(control.value.trim())) {
            result.customEmail = true;
            error = true;
        }

        return error ? result : null;
    }
}
